import { dealStore } from '@/models/stores';
import { values } from 'lodash';
import useHubs from './use-hubs';

// TODO: make a provider for this
const useDealList = () => {
  const { hubPathIdentifier } = useHubs();
  // DEV NOTE: we are purposefully using the /all endpoint
  // even for the deal list. The reason is because for now it's easier to manage
  // because it makes the state management easier.

  const dealsListData = dealStore.getDealsListData({
    hubPathIdentifier,
  });
  const dealCount = values(dealsListData).reduce(
    (acc: number, curr) => acc + curr.count,
    0,
  );

  return { dealsListData, isLoading: false, dealCount };
};

export default useDealList;
